<template>
  <div id="container">
    <div class="box_one" > 
      <cont-top/>
    </div>     
    <div class="main" style="margin-bottom:5px"> 

      <div class="title">
        <div class="title_name"></div>
      </div>

      <div class="clear" style="padding:0 40px">
        <div style="width:203px;float:right;margin-left:70px">
          <el-image
            style="width:202px; margin-bottom:20px"
            :src="require('@/assets/image/brand/DJHoldings/img3.png')"
            fit="fit">
          </el-image>
          <el-image
            style="width:202px; margin-bottom:20px"
            :src="require('@/assets/image/brand/DJHoldings/img4.png')"
            fit="fit">
          </el-image>
        </div>

        <div style="font-size:18px">
          <div style="margin-bottom:40px;margin-top:40px;text-indent:40px">
            株式会社DJ HOLDINGS是以股权交换的形式，于2018年成立。基于长期发展战略、灵活的人事、经营资源的有效活用为主旨，以中立的立场以求集团全体能够有着更长足的发展与飞跃。
          </div>
          <div style="margin-bottom:40px;text-indent:40px">
            随着DJ HOLDINGS的设立，DJ HOLDINGS与DIXCEL本社在同年7月进驻新办公大楼、新研发中心以及新仓库。至此，我们更加期待产能的增加以及更有效率的工作能为公司前进打下更为扎实的基础。同时，我们还引进了最先进的测试设备来满足自社研发测试的需求。
          </div>
          <div style="margin-bottom:40px;text-indent:40px">
            DJ HOLDINGS的设立将更进一步发掘公司将来各个领域的可能性，同时将尽力支援各分公司在发展的道路上所需要的一切所需。我们相信各个分公司在各个领域的成长壮大也必将使得DJ HOLDINGS集团更为强大。
          </div>
        </div>



      </div>

    </div>    
    <div class="box_bottom" > 
      <cont-bottom/>
    </div>
  </div>
</template>

<script>
import ContTop from './Cont_top'
import ContBottom from '@/views/Components/Cont_bottom'


export default {
  data() {
    return {
      fit : 'contain'
    }
  },
  components : {
    ContTop ,
    ContBottom ,
  }
}

</script>

<style lang="stylus" scoped>
.clear:after {
  display: block;
  clear: both;
  content: '';
}

#container
  background-color : #000
  .box_one 
    width: 100%;
    // background: url("~@/assets/image/brand/img1.png");
    background-repeat : no-repeat 
    background-size : cover
    background-color : #000

  .box_bottom
    width: 100%;
    background-color #000


.main {
  margin-bottom: 5px;
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding: 55px 0 44px
}

.title {
  position: absolute;
  width: 214px;
  height: 108px;
  left: 66px;
  top: -68px;
  background: url('~@/assets/image/brand/DJHoldings/img1.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 33px 41px 19px 23px; 
  box-sizing: border-box;
}

.title_name {
  width: 150px;
  height: 56px;
  background: url('~@/assets/image/brand/DJHoldings/img2.png');
  background-repeat: no-repeat;
  background-size: contain;
}

</style>